import { GoogleUserProfile } from "@/shared/types";
import { create } from "zustand";

export type AuthGrant = "member" | "admin" | null;

interface AuthStoreState {
  user: GoogleUserProfile | null;
  grant: AuthGrant;
  isLoading: boolean;
  memberId: number | null;
  phone: string | null;
  setAuth: (auth: { user: GoogleUserProfile | null; grant: AuthGrant; memberId: number | null; phone: string | null }) => void;
  setPhone: (phone: string | null) => void;
  setGrant: (grant: AuthGrant) => void;
  setLoading: (loading: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthStoreState>((set) => ({
  user: null,
  grant: null,
  isLoading: true,
  memberId: null,
  phone: null,

  setAuth: ({ user, grant, memberId, phone }) => set({ user, grant, memberId, phone }),
  setPhone: (phone) => set({ phone }),
  setGrant: (grant) => set({ grant }),
  setLoading: (isLoading) => set({ isLoading }),
  clearAuth: () => set({ user: null, grant: null, isLoading: false, memberId: null, phone: null }),
}));
